const MainTitle = ({title}) => {
    return <h1 className="main-title">{ title}</h1>;
}
 
export default MainTitle;